module.exports = [
    {
        title: {
            en: "About you",
            cy: ""
        },

        permalink: {
            en: "have-your-say/feedback-form/your-details",
            cy: "dweud-eich-dweud/ffurflen-adborth/your-details"
        },

        parent: {
            en: "have-your-say",
            cy: "dweud-eich-dweud"
        },

        type: "contact",

        subSections: [
            {
                groups: [
                    {
                        questions: [
                            {
                                label: {
                                    en: "Name",
                                    cy: ""
                                },
                                name: "name", // or name if contact section
                                type: "text", // text, radio, checkbox
                                required: true
                            },
                            {
                                label: {
                                    en: "Address",
                                    cy: ""
                                },
                                name: "address", // or name if contact section
                                type: "text" // text, radio, checkbox
                            },
                            {
                                label: {
                                    en: "Postcode",
                                    cy: ""
                                },
                                name: "postcode", // or name if contact section
                                type: "text" // text, radio, checkbox
                            },
                            {
                                label: {
                                    en: "Telephone number",
                                    cy: ""
                                },
                                name: "telephone", // or name if contact section
                                type: "tel" // text, radio, checkbox
                            },
                            {
                                label: {
                                    en: "Email",
                                    cy: ""
                                },
                                name: "email", // or name if contact section
                                type: "email", // text, radio, checkbox
                                required: true
                            },
                            {
                                label: {
                                    en: "Please tick the box that describes you best",
                                    cy: ""
                                },
                                name: "describes-you", // or name if contact section
                                type: "checkbox", // text, radio, checkbox

                                // For radio or checkbox only
                                options: [
                                    {
                                        en: "I am a local resident",
                                        cy: ""
                                    },
                                    {
                                        en: "Community group representative",
                                        cy: ""
                                    },
                                    {
                                        en: "I represent an organisation",
                                        cy: ""
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        title: {
            en: "Design",
            cy: ""
        },

        permalink: {
            en: "have-your-say/feedback-form/section-1",
            cy: "dweud-eich-dweud/ffurflen-adborth/section-1-welsh"
        },

        parent: {
            en: "have-your-say",
            cy: "dweud-eich-dweud"
        },

        type: "questions", // questions, contact

        subSections: [
            {
                groups: [
                    {
                        questions: [
                            {
                                label: {
                                    en: "Do you have any comments on the proposed design of the MSA, including the buildings, landscaping features and green space?",
                                    cy: ""
                                },
                                number: "1", // or name if contact section
                                type: "text" // text, radio, checkbox
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        title: {
            en: "Managing traffic",
            cy: ""
        },

        permalink: {
            en: "have-your-say/feedback-form/section-2",
            cy: "dweud-eich-dweud/ffurflen-adborth/section-2-welsh"
        },

        parent: {
            en: "have-your-say",
            cy: "dweud-eich-dweud"
        },

        type: "questions", // questions, contact

        subSections: [
            {
                groups: [
                    {
                        questions: [
                            {
                                label: {
                                    en: "Do you have any comments on how we propose to manage traffic in and around the site?",
                                    cy: ""
                                },
                                number: "2", // or name if contact section
                                type: "text" // text, radio, checkbox
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        title: {
            en: "Environment",
            cy: ""
        },

        permalink: {
            en: "have-your-say/feedback-form/section-3",
            cy: "dweud-eich-dweud/ffurflen-adborth/section-3-welsh"
        },

        parent: {
            en: "have-your-say",
            cy: "dweud-eich-dweud"
        },

        type: "questions", // questions, contact

        subSections: [
            {
                groups: [
                    {
                        questions: [
                            {
                                label: {
                                    en: "Do you have any comments on the environmental aspects of the proposals, including the proposed landscaping and drainage?",
                                    cy: ""
                                },
                                number: "3", // or name if contact section
                                type: "text" // text, radio, checkbox
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        title: {
            en: "EV Charging",
            cy: ""
        },

        permalink: {
            en: "have-your-say/feedback-form/section-4",
            cy: "dweud-eich-dweud/ffurflen-adborth/section-4-welsh"
        },

        parent: {
            en: "have-your-say",
            cy: "dweud-eich-dweud"
        },

        type: "questions", // questions, contact

        subSections: [
            {
                groups: [
                    {
                        questions: [
                            {
                                label: {
                                    en: "Do you have any comments on our proposals for electric vehicle and eHGV charging?",
                                    cy: ""
                                },
                                number: "4", // or name if contact section
                                type: "text" // text, radio, checkbox
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        title: {
            en: "Other comments",
            cy: ""
        },

        permalink: {
            en: "have-your-say/feedback-form/section-5",
            cy: "dweud-eich-dweud/ffurflen-adborth/section-5-welsh"
        },

        parent: {
            en: "have-your-say",
            cy: "dweud-eich-dweud"
        },

        type: "questions", // questions, contact

        subSections: [
            {
                groups: [
                    {
                        questions: [
                            {
                                label: {
                                    en: "Do you have any other comments on our proposals?",
                                    cy: ""
                                },
                                number: "5", // or name if contact section
                                type: "text" // text, radio, checkbox
                            }
                        ]
                    }
                ]
            }
        ]
    },

    // Do not remove these sections!
    {
        title: {
            en: "Review",
            cy: "Adolygiad"
        },

        permalink: {
            en: "have-your-say/feedback-form/review",
            cy: "dweud-eich-dweud/ffurflen-adborth/adolygiad"
        },

        parent: {
            en: "have-your-say",
            cy: "dweud-eich-dweud"
        },

        type: "review",
    },
    {
        title: {
            en: "Success",
            cy: "Llwyddiant"
        },

        permalink: {
            en: "have-your-say/feedback-form/success",
            cy: "dweud-eich-dweud/ffurflen-adborth/llwyddiant"
        },

        parent: {
            en: "have-your-say",
            cy: "dweud-eich-dweud"
        },

        type: "success",
    },
];
